import { Pill } from '@iwoca/orion';
import styles from './StatusCell.module.css';

type TProps = { isActive: boolean };

export const StatusCell = ({ isActive }: TProps) => {
  return (
    <Pill
      variant={isActive ? 'green' : 'london'}
      size="small"
      className={isActive ? undefined : styles.inactivePill}
    >
      {isActive ? 'Active' : 'Inactive'}
    </Pill>
  );
};
